import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GenericResModel } from 'countable@model';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AclModel } from '../model/acl.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AclService {

  private static readonly URI_ACL = environment.apiV1 + '/user/acl';
  public readonly subject = new ReplaySubject<AclModel>(1);

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.subjectUserDetail.pipe(takeUntilDestroyed()).subscribe(() => {
      this.refresh();
    });
  }

  public refresh(): void {
    this.http.get<GenericResModel<AclModel>>(AclService.URI_ACL).pipe(
      tap((res) => {
        if (res.status === 200) {
          this.subject.next(res.data);
        }
      })).subscribe();
  }
}
